import { LogManager } from "../../../../common/port/log/log.manager.port";
import { CalendarTimeSeriesMetricsSummaryAggregateRootMapper } from "../../../../infrastructure/mappers/calendar/time-series/get-calendar-time-series-metrics-summary-aggregate-root.mapper";
import { GetCalendarAppTimeSeriesMetricsRequestDto } from "../../../dtos/calendar/time-series/get-calendar-time-series-metrics.request.dto";
import { GetSelfCalendarAppTimeSeriesMetricsSummaryResponseDto } from "../../../dtos/calendar/time-series/get-calendar-time-series-metrics.response.dto";
import { GetCalendarAppTimeSeriesMetricsSummaryQuery } from "../../../queries/calendar/time-series/get-calendar-score-time-series-metrics-summary.query";

export class GetCalendarAppTimeSeriesMetricsSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetCalendarAppTimeSeriesMetricsSummaryQuery,
    protected readonly mapper: CalendarTimeSeriesMetricsSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetCalendarAppTimeSeriesMetricsRequestDto
  ): Promise<GetSelfCalendarAppTimeSeriesMetricsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetCalendarAppTimeSeriesMetricsController.get encountered an error ${error}`
      );
    }
  }
}
